import { Provider, Type } from '@angular/core'
import {
  DefaultMissingTranslationHandler,
  Language,
  MissingTranslationHandler,
  provideTranslateService,
  TranslateCompiler,
  TranslateDefaultParser,
  TranslateLoader,
  TranslateNoOpCompiler,
  TranslateParser,
} from '@ngx-translate/core'

/**
 * `provideTranslateService` with explicit `useClass` providers: ngx-translate tells a class from a factory with
 * `/^class\s/` on its source, which fails on minified `X=class{…}` and calls the class without `new` in production.
 */
export function provideTranslations(loader: Type<TranslateLoader>, fallbackLang?: Language): Provider[] {
  return provideTranslateService({
    fallbackLang,
    loader: { provide: TranslateLoader, useClass: loader },
    compiler: { provide: TranslateCompiler, useClass: TranslateNoOpCompiler },
    parser: { provide: TranslateParser, useClass: TranslateDefaultParser },
    missingTranslationHandler: { provide: MissingTranslationHandler, useClass: DefaultMissingTranslationHandler },
  })
}
